import { ModelBase } from '../../core/model/model-base';
import { ArticleUnit, CustomPropertyDataType, CustomPropertyTypeToString } from './const/enums';

export class CustomProperty extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.id = dataContext.id;
      this.caption = dataContext.caption;
      this.dataType = dataContext.dataType;
      this.decimalCount = dataContext.decimalCount;
      this.unit = dataContext.unit;
      this.minValue = dataContext.minValue;
      this.maxValue = dataContext.maxValue;
      this.selectableValues = dataContext.selectableValues;
      this.availableOnCompany = dataContext.availableOnCompany;
      this.availableOnDwelling = dataContext.availableOnDwelling;
      this.availableOnProperty = dataContext.availableOnProperty;
      this.availableOnBuilding = dataContext.availableOnBuilding;
      this.availableOnPremises = dataContext.availableOnPremises;
    } else {
      this.caption = '';
      this.dataType = CustomPropertyDataType.Text;
      this.decimalCount = 0;
      this.unit = ArticleUnit.None;
      this.minValue = null;
      this.maxValue = null;
      this.selectableValues = 'Abc 1\nAbc 2';
      this.availableOnCompany = false;
      this.availableOnDwelling = false;
      this.availableOnProperty = false;
      this.availableOnBuilding = false;
      this.availableOnPremises = false;
    }
  }

  caption: string;
  dataType: CustomPropertyDataType;
  decimalCount: number;
  availableOnCompany: boolean;
  availableOnDwelling: boolean;
  availableOnProperty: boolean;
  availableOnBuilding: boolean;
  availableOnPremises: boolean;
  unit: ArticleUnit;
  minValue: number;
  maxValue: number;
  selectableValues: string;

  get dataTypeCaption(): string {
    return CustomPropertyTypeToString(this.dataType);
  }

  toString() {
    return `${this.caption}`;
  }
}
